<template lang="pug">
.content 
  AppTemplate(
    pagetitle= "推广分析",
    tip= "推广分析报告为您展示应用推广的推广及效果数据帮助您及时了解您的应用推广状态，依据效果数据优化推广账户",
    :currentTab= "currentTab",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sum= "sum",
    :yAxis="yAxis",
    :legend= "legend", 
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    @indiceChange= "indiceChange",
    @tableUpdate= "getTableData",
    @clearKeyword="clearKeyword",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")

    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        DownloadBtn(
          slot="extentTab",
          :reportApi="reportApi",
          :params="query",
          :pagetitle="tableTabTitle",
          subtitle="",
          v-if="total > 0")
        div(slot="common")
          p.plan-nav(v-show="currentTab == 'planId'")
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
            v-select(
              v-show="currentTab == 'advertId'",
              v-model="planselected",
              @input="onPlanChange",
              :options="planlistOptions"
              )
            Search(
              v-show="currentTab != 'product'",
              :placeholder="placeHolder",
              @doSearch="doSearch",
              :defaultValue="keyword")
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
  import Store from '../../store/store.js'
  import AppTemplate from './template'
  import Mixin from '../mixin.js'
  export default {
    store: Store,
    components: {
      AppTemplate
    },
    mixins: [Mixin],
    data() {
      return {
        keyword: "",
        isasc: 0,
        total: 0,
        pg: 1,
        ps: 10,
        order: "date",
        customIndice: "adpv",
        twoIndiceShow: true,
        twoIndice: "",
        legend: [],
        yAxis: [],
        chartXAxis: [],
        chartSeries: [],
        chartResList: [],
        hasCheckBox: false,
        checkboxLength: 3,
        sum: {},
        tableDataList: [],
        planselected: 0,
        planlistOptions: [
          {value: 0, label: '全部推广计划'}
        ],
        sdim: 'null',
        currentTab: 'product',
        tablist: [
          {
              id: 'product', 
              name: '推广趋势', 
              key: 'date',
              order: 'date',
              reportTableApi:'/api/appreport/BooladProduct?groupby=date,product',
              basicSummaryStatApi: '/api/appreport/BooladProduct?issum=1',
              reportLineChartApi: '/api/appreport/BooladProduct?groupby=date,product'
          },
          {
              id: 'planId', 
              name: '推广计划', 
              order: 'adpv',
              reportTableApi:'/api/appreport/BooladPlan?groupby=plan',
              basicSummaryStatApi:'/api/appreport/BooladPlan?issum=1&groupby=plan',
              reportLineChartApi:'/api/appreport/BooladPlan?groupby=plan,date'
          },
          {
              id: 'advertId', 
              name: '创意', 
              order: 'adpv',
              reportTableApi:'/api/appreport/BooladAdvert?groupby=advert',
              basicSummaryStatApi:'/api/appreport/BooladAdvert?issum=1&groupby=advert',
              reportLineChartApi:'/api/appreport/BooladAdvert?groupby=advert,date'
          }
        ],
        sdimOptions: []
      }
    },
    computed: {
      ...mapState('app', {
        indicesMenu: state => state.indicesMenu,
        dianjingID: state => state.dianjingID,
        dianjingIDList: state => state.dianjingIDList,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      uiError() {
        return this.$store.state.uiError
      },
      fetchLineChartabled() {
        return this.$store.state.tableCheckList.length == 0 || !this.$store.state.drawChartabled
      },
      twoIndiceSelectabled() {
        return this.$store.state.tableCheckList.length > 1
      },
      tableTabTitle () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      query(){ 
        let query={
              isasc: this.isasc,
              order: this.order,
              pvtype: 0,
              start: this.$store.state.start,
              end: this.$store.state.end,
              cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
              timespan: new Date().getTime(),
              djid: this.dianjingID,
              mdim: this.currentTab
            }
        if(this.compared){
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if(this.sdim != "null"){
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if(this.keyword) {
          //advertId时传参为advert，planId传参是为plan
          query = _.assignIn({
            [this.currentTab.replace(/Id/, '')]: this.keyword
          }, query)
        }
        if(this.planselected){
          query = _.assignIn({
            planId: this.planselected
          }, query)
        }
        return query
      },
      reportApi() {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      },
      placeHolder() {
        return '请输入' + _.find(this.tablist, {id: this.currentTab}).name
      }
    },
    created() {
      if(this.dianjingIDList.length == 0) {
        this.getDianjingIDs()
      }
      this.setDianjingId(0)
    },
    watch: {
      uiError() {
        this.$Modal.warn(this.uiError.errMsg)
      },
      dianjingID() {
        this.keyword = ''
      },
      compared: function(newVal, oldVal){
        if(newVal){
          this.checkboxLength = 1
        }else{
          this.checkboxLength = 3
        }
      }
    },
    methods: {
      ...mapActions('app', {
        setCompared: 'SET_COMPARED',
        setDianjingId: 'SET_DIANJINGID',
        setDinajingIdList: 'SET_DIANJINGID_LIST',
      }),
      tablesorter({key, order}) {
        this.sorter(key, order)
      },
      doSearch(keyword) {
        this.keyword = keyword
        this.getTableData()
      },
      updateTab(tab) {
        if(this.currentTab == tab) return
        this.resetTab(tab)
        this.setCompared(false)
        this.resetIndice()
        this.keyword = ''
        this.planselected = 0
        if(this.currentTab == 'product'){
          this.hasCheckBox = false
        }else{
          this.hasCheckBox = true
        }
        this.getTableData()
      },
      onPlanChange() {
        this.keyword = ''
        this.getTableData()
      },
      getOtherList() {
        if(this.currentTab == 'advertId'){
          this.getPlanList()
        }
      },
      getPlanList() {
        if(!this.dianjingIDList.length) return
        let planlistPromise = this.$http.get('/api/boolad/planlist', {  params: _.assignIn({}, _.pick(this.query, ['cycle','start','end','timespan']))
        })
        this.$store.dispatch("VUE_HTTP", [planlistPromise])
          .then((res) => {
            if(res) {
              let planlist = []
              if(res.list.length > 0){
                planlist = res.list.map(item => {
                  return {
                    value : item.id,
                    label : item.name
                  }
                })
              }
              planlist = _.concat(this.planlistOptions, planlist)
              this.planlistOptions = _.uniqBy(planlist, "value")
            }
          })
      }
    }
  }
</script>
<style scoped>
.search {
  float: right;
}
</style>



// WEBPACK FOOTER //
// promotion.vue?6626021e